/* eslint-disable import/first */
import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { useIntl, FormattedMessage } from 'react-intl';
import { useNavigate, useLocation } from '@reach/router';
import css from './index.module.scss';

export default function NotLogged({
  address,
  topbar,
  heading,
  subHeading,
  title,
  img,
  url,
  delivery = false,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();
  const { oldLocation } = location.state || [];
  const loginNavigation = () => {
    delivery
      ? navigate(`/${intl.locale}/login`, {
          state: { component: 'delivery', oldLocation: oldLocation },
        })
      : navigate(`/${intl.locale}/login`, {
          state: { oldLocation: oldLocation, retUrl: url || '/order-history' },
        });
  };
  return (
    <div className={css.root}>
      <main className={css.main}>
        {address && {}}
        <div className={css.section}>
          <div className={css.login}>
            <img src={img} alt="" />
            {/*  eslint:fix alt is added in img tag */}
            <p className={css.headerText}>{heading}</p>
            <p className={css.descText}>{subHeading}</p>
            <Grid>
              <Button
                variant="contained"
                color="primary"
                size="large"
                className={css.buttonPrimary}
                onClick={loginNavigation}
              >
                <FormattedMessage id="navigation_login" defaultMessage="login" />
              </Button>
            </Grid>
          </div>
        </div>
      </main>
    </div>
  );
}
